import React, { useState } from "react";
import Toast from "react-bootstrap/Toast";
import Icon from "./Icon";
import { dequeue, NotificationEvent } from "../notifications/notifications";

interface NotificationPopupProps {
  children: React.ReactNode | string;
  delay: number;
  autohide: boolean;
  variant: string;
  id: string;
}

export const NotificationPopup: React.FC<NotificationPopupProps> = ({
  children,
  variant,
  id,
  delay,
  autohide
}) => {
  const [show, setShow] = useState(true);
  const onClose = () => {
    setShow(false);
    dequeue();
    const event = new CustomEvent(NotificationEvent.DELETE, {
      detail: {
        id
      }
    });
    document.dispatchEvent(event);
  };
  return (
    <Toast
      bsPrefix="notification-popup"
      show={show}
      delay={delay}
      onClose={onClose}
      autohide={autohide}
      className={`notification-popup--${variant}`}
    >
      <Icon
        name="bell-ringing"
        className="notification-popup__notification-icon"
      />
      <div className="notification-popup__content" data-testid="notification">
        {children}
      </div>
      <Icon
        name="close"
        onClick={() => onClose()}
        className="notification-popup__close-icon"
      />
    </Toast>
  );
};
